<template>
  <div class="transparent-page">
    <!-- <div ref="tcaptchaContainer"></div> -->
    <!-- <button @click="loadTcaptcha">验证</button> -->
    <p v-if="getCaptchaAppIdErr">获取验证码ID失败</p>
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref, nextTick } from 'vue';

import { isAndroid, isIOS } from '@/fe_modules/utils/env';

import { getCaptchaAppId } from './api';

const isScriptLoaded = ref(false); // 用于记录是否已经加载过 TCaptcha.js
const StrCaptchaAppId = ref('');
const options = {
  needFeedBack: false
};
const getCaptchaAppIdErr = ref(false);
// document.body.style.backgroundColor = 'transparent';
onMounted(() => {
  addMeta(
    'Permissions-Policy',
    'accelerometer=(), gyroscope=(), magnetometer=(), microphone=(), camera=(), display-capture=(), usb=(), vr=()'
  );
  getCaptchaAppId()
    .then((res) => {
      console.log('getCaptchaAppId', res);
      if (res.code == 0) {
        StrCaptchaAppId.value = res.data.CaptchaAppId;
        nextTick(() => {
          loadTcaptcha();
        })
      } else {
        getCaptchaAppIdErr.value = true;
      }
    })
    .catch((err) => {
      getCaptchaAppIdErr.value = true;
    });
});
const addMeta = (name: string, content: string) => {
  const meta = document.createElement('meta');
  meta.content = content;
  meta.httpEquiv = name;
  document.getElementsByTagName('head')[0].appendChild(meta);
};

const loadTcaptcha = () => {
  if (!isScriptLoaded.value) {
    const script = document.createElement('script');
    script.src = 'https://turing.captcha.qcloud.com/TCaptcha.js';
    script.async = true;
    script.onload = () => {
      isScriptLoaded.value = true; // 标记为已加载
      initializeTcaptcha(); // 加载完成后初始化
    };
    document.head.appendChild(script);
  } else {
    initializeTcaptcha(); // 如果已经加载过，直接初始化
  }
};
const initializeTcaptcha = () => {
  console.log('StrCaptchaAppId', StrCaptchaAppId);
  try {
    const captcha = new window.TencentCaptcha(
      StrCaptchaAppId.value,
      callback,
      options
    );
    // 调用方法，显示验证码
    captcha.show();
  } catch (error) {
    // 加载异常，调用验证码js加载错误处理函数
    loadErrorCallback();
  }
};

// 定义验证码js加载错误处理函数
function loadErrorCallback() {
  var appid = StrCaptchaAppId.value;
  // 生成容灾票据或自行做其它处理
  var ticket =
    'terror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000);
  callback({
    ret: 0,
    randstr: '@' + Math.random().toString(36).substr(2),
    ticket: ticket,
    errorCode: 1001,
    errorMessage: 'jsload_error'
  });
}

// 定义回调函数
function callback(res: any) {
  // 第一个参数传入回调结果，结果如下：
  // ret         Int       验证结果，0：验证成功。2：用户主动关闭验证码。
  // ticket      String    验证成功的票据，当且仅当 ret = 0 时 ticket 有值。
  // CaptchaAppId       String    验证码应用ID。
  // bizState    Any       自定义透传参数。
  // randstr     String    本次验证的随机串，后续票据校验时需传递该参数。
  // res（用户主动关闭验证码）= {ret: 2, ticket: null}
  // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
  // res（请求验证码发生错误，验证码自动返回terror_前缀的容灾票据） = {ret: 0, ticket: "String", randstr: "String",  errorCode: Number, errorMessage: "String"}
  // 此处代码仅为验证结果的展示示例，真实业务接入，建议基于ticket和errorCode情况做不同的业务处理
  if (res) {
    reFlu(res);
  }
}

const reFlu = (res: any) => {
  const jsonString = JSON.stringify(res);

  if (isIOS()) {
    window.webkit.messageHandlers.jsToFlutterWithParams &&
      window.webkit.messageHandlers.jsToFlutterWithParams.postMessage(
        jsonString
      );
  } else if (isAndroid()) {
    window.jsToFlutterWithParams &&
      window.jsToFlutterWithParams.postMessage(jsonString);
  }
};
</script>
<style lang="scss" scoped></style>
